// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1B7Hu","left":"styles_left__2ZPtU","right":"styles_right__oof3d","alert":"styles_alert__3hJFY"};